export class QRInput {
  mode!: string;
  hierarchy!: string;
  size!: number;
  placeholder?: string = '';
  type?: string = QRInput.TYPE_TEXT;
  icon?: string = '';
  isCleanButtonVisible?: boolean = false;
  debounceTime?: number = 0;
  maxLength?: number | null;
  hint?: string;
  hintRight?: string;
  errorMsg?: string;
  allowedPattern?: RegExp;
  isTogglePasswordVisible?: boolean = false; // Para mostrar el toggle de contraseña oculta/visible
  // Jerarquía
  public static readonly HIERARCHY_1 = 'hierarchy-1';
  // Tamaños
  public static readonly SIZE_MEDIUM = 40;
  // Modos
  public static readonly MODE_STRING = 'MODE_STRING'; // Habilitar modo cadena de textos
  public static readonly MODE_INTEGER = 'MODE_INTEGER'; // Habilitar solo números enteros
  public static readonly MODE_DECIMAL = 'MODE_DECIMAL'; // Habilitar solo números y posibilidad de decimales
  // Tipos
  public static readonly TYPE_TEXT: string = 'text';
  public static readonly TYPE_PASSWORD: string = 'password';
}
